export enum GridDataStatus {
  isLoading,
  hasNoItems,
  dataLoaded,
  errorOccurred,
  cancelLoading
}
